import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createCurriculum, createEmergencyContact, createMeal, deleteCurriculum, fetchCurriculumCategory, fetchCurriculumPlan, fetchEmergencyContact, removeEmergencyContact, updateCurriculum, updateEmergencyContact, updateStatusCurriculum } from "../../../service/api";


export const getEmergencyContact = createAsyncThunk(
    "contact/getContact",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchEmergencyContact(params)
            console.log("emergency contact", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const addEmergencyContact = createAsyncThunk(
    "contact/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createEmergencyContact(formValue)
            if (response.status === 201) {
                console.log("meals", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

export const editEmergencyContact = createAsyncThunk(
    "contact/edit",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await updateEmergencyContact(formValue)
            if (response.status === 201) {
                console.log("edit contact", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const deleteEmergencyContact = createAsyncThunk(
    "contact/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await removeEmergencyContact(formValue)
            if (response.status === 201) {
                console.log("delete contact", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


const contactSlice = createSlice({
    name: "emergencyContact",
    initialState: {
        contactList: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        searchParams: "",

    },
    reducers: {
        
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
       
    },

    extraReducers: (builder) => {
        builder
            //GET
            .addCase(getEmergencyContact.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })

            .addCase(getEmergencyContact.fulfilled, (state, action) => {
                state.isLoading = false;
                state.contactList = action.payload.data;

            })

            .addCase(getEmergencyContact.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addEmergencyContact.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addEmergencyContact.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addEmergencyContact.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // PUT
            .addCase(editEmergencyContact.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editEmergencyContact.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editEmergencyContact.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // delete
            .addCase(deleteEmergencyContact.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteEmergencyContact.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteEmergencyContact.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams} = contactSlice.actions;

export default contactSlice.reducer;
